import {
  ADRESSVORSCHLAG_FAILED_REASON,
  isAuslandsrisikoort,
  MapCoordinates,
  Risikoort,
} from '@ps20-frontend/frontend-models';
import { Auslandsrisiko } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { selectAdressvorschlagError } from './adressvorschlag.selector';
import { selectVhvVorhandenError } from './transient-state.selector';

export const selectRisikoort = (state: IAppState): Risikoort => state.risikoort as Risikoort;

export const selectRisikoortHasCoordinates = (state: IAppState): boolean =>
  !!(state.risikoort?.longtitude && state.risikoort?.latitude);

export const selectRisikoortHasNonFormError = (state: IAppState): boolean => {
  const adressvorschlagError = selectAdressvorschlagError(state);
  return (
    adressvorschlagError === ADRESSVORSCHLAG_FAILED_REASON.ADRESS_INVALID ||
    adressvorschlagError === ADRESSVORSCHLAG_FAILED_REASON.PLZ_INVALID ||
    selectVhvVorhandenError(state) != null
  );
};

export const selectAuslandsadresse = (state: IAppState): string => state.risikoort?.auslandsadresse;
export const selectAuslandsrisiko = (state: IAppState): Auslandsrisiko =>
  state.risikoort.auslandsrisiko;
export const selectIsAuslaendischeAdresse = (state: IAppState): boolean =>
  isAuslandsrisikoort(state.risikoort);

export const selectMapCoordinates = (state: IAppState): MapCoordinates => {
  return { lat: state.risikoort.latitude, lon: state.risikoort.longtitude } as MapCoordinates;
};
